import { NxIconModule } from "@allianz/ng-aquila/icon";
import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";

@Component({
  selector: "app-custom-stepper",
  templateUrl: "./custom-stepper.component.html",
  styleUrls: ["./custom-stepper.component.scss"],
  standalone: true,
  imports: [CommonModule, NxIconModule],
})
export class CustomStepperComponent {
  @Input() public dataList;

  private getImageType(name) {
    const parts = name.split(".");
    const fileExtension = parts[parts.length - 1].toLowerCase();
    return this.getMimeType(fileExtension);
  }
  private getMimeType(fileType) {
    switch (fileType) {
      case "jpg":
        return "image/jpeg";
      case "png":
        return "image/png";
      case "svg":
        return "image/svg+xml";
      default:
        return "image/png"; // Default to PNG
    }
  }

  protected getImageInfo(data) {
    if (data.status !== "INCOMPLETE") {
      return (
        "data:" +
        this.getImageType(data.badgeFilename) +
        ";base64," +
        data.badgeBase64
      );
    }

    return "assets/images/shared/campaign/disabled.svg";
  }

  protected getStepClass(item: any): string {
    if (item.status === "COMPLETED") {
      return "completed";
    } else if (item.status === "ONGOING") {
      return "active";
    } else {
      return "disable";
    }
  }

  protected isCompleted(item: any): boolean {
    return item.status === "COMPLETED";
  }
}
